<script lang="ts">
  import { onMount } from "svelte";
  import { croquis } from "../utils/croquis";

  onMount(() => {
    croquis();
  });
</script>

<canvas id="sig-canvas" class="sig-canvas" width="800" height="300" />

<style>
  :global(.sig-canvas) {
    border: 2px dotted #cccccc;
    border-radius: 15px;
    cursor: crosshair;
  }
</style>
